import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from "react";
import { Link } from "./library/link";
import { Teasers } from "./teaser";
export class ContentGridBlock extends React.Component {
    render() {
        const p = this.props;
        return /*#__PURE__*/ _jsxs("section", {
            className: "block block--content-grid container--lg align--center",
            children: [
                p.title && p.title != "" && /*#__PURE__*/ _jsx("header", {
                    className: "block__header container--m align--center",
                    children: /*#__PURE__*/ _jsx("h2", {
                        className: "block__title title--l container--xs",
                        children: p.title
                    })
                }),
                /*#__PURE__*/ _jsx(Teasers, {
                    items: p.items.map((i, k)=>({
                            key: `content-grid-item-${k}`,
                            extraClasses: 'block__item col-xs-12 col-sm-6 col-md-4',
                            headingLevel: p.title && p.title != "" ? 'h3' : 'h2',
                            title: i.title,
                            linkUrl: i.linkUrl,
                            intro: i.subtitle,
                            label: i.label,
                            imageUrl: i.imageUrl,
                            imageUrlFallback: i.imageUrlFallback,
                            imageUrlLarge: i.imageUrlLarge,
                            imageAlt: i.imageAlt,
                            video: i.video
                        })).toList()
                }),
                p.primaryActionTitle && p.primaryActionUrl && /*#__PURE__*/ _jsx("footer", {
                    className: "block__actions container--m align--center",
                    children: /*#__PURE__*/ _jsx(Link, {
                        className: "button button--primary button--arrow",
                        url: p.primaryActionUrl,
                        children: p.primaryActionTitle
                    })
                })
            ]
        });
    }
}
{}